import i18n from '@/i18n';
import { FormFieldDescriptor } from '@/features/common/helpers/scrollToError';

export const commercialInvoiceFormFields: FormFieldDescriptor[] = [
  // General info
  {
    elementId: 'ci-reason-for-export',
    name: i18n.t('shipment.commercialInvoice.labels.reasonForExport') as string,
    priority: 1,
  },
  {
    elementId: 'ci-general-description',
    name: i18n.t('shipment.commercialInvoice.labels.generalDescription') as string,
    priority: 2,
  },
  {
    elementId: 'ci-currency-code',
    name: i18n.t('shipment.commercialInvoice.labels.currency') as string,
    priority: 3,
  },
  {
    elementId: 'ci-declaration-statement',
    name: i18n.t('shipment.commercialInvoice.labels.declarationStatement') as string,
    priority: 4,
  },
  // Parts
  {
    elementId: 'ci-quantity',
    name: i18n.t('labels.qty') as string,
    priority: 5,
  },
  {
    elementId: 'ci-quantity-units',
    name: i18n.t('shipment.commercialInvoice.labels.qtyUnits') as string,
    priority: 6,
  },
  {
    elementId: 'ci-unit-value',
    name: i18n.t('labels.unitValue') as string,
    priority: 7,
  },
  {
    elementId: 'ci-hs-code',
    name: i18n.t('shipment.commercialInvoice.labels.hsCode') as string,
    priority: 8,
  },
  {
    elementId: 'ci-country-of-origin',
    name: i18n.t('shipment.commercialInvoice.labels.countryOfOrigin') as string,
    priority: 9,
  },
  {
    elementId: 'ci-detailed-description',
    name: i18n.t('shipment.commercialInvoice.labels.detailedDescription') as string,
    priority: 10,
  },
];
